import cookie from 'react-cookie'
import constant from '../constants/index'

export const getCSRFToken = () => cookie.load(constant.SOCIAL_TOKEN)

export const getTWToken = () => cookie.load(constant.TWITTER_TOKEN)

export const getTWSecret = () => cookie.load(constant.TWITTER_SECRET)

/**
 * Function working as getter OR setter.
 * If passed mappTracking parameter, it will be stored in the cookies
 * If mappTracking parameter is not passed, function return mappTracking data from cookies
 * @param {object} mappTracking
 * @param mappTracking
 * @returns {object} mapp tracking parameters
 */
export const mappTrackingCookie = (mappTracking = undefined) => {
  if (mappTracking !== undefined) {
    cookie.save('mappTrackingParameters', JSON.stringify(mappTracking), { path: '/' })
  }

  let tracking = cookie.load('mappTrackingParameters')
  if (tracking === undefined) {
    tracking = { platform: '', element: '', referrer: '' }
  }

  return tracking
}



// WEBPACK FOOTER //
// ./src/services/cookies.js